/**
 * @flow
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteFragment } from 'relay-runtime';
type Absences_user$ref = any;
type Account_user$ref = any;
type BaseHorizontal_user$ref = any;
type Dashboard_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Routes_user$ref: FragmentReference;
export type Routes_user = {|
  +displayName: ?string,
  +isStaff: boolean,
  +$fragmentRefs: BaseHorizontal_user$ref & Dashboard_user$ref & Account_user$ref & Absences_user$ref,
  +$refType: Routes_user$ref,
|};
*/

const node /*: ConcreteFragment*/ = (function () {
  var v0 = [
    {
      kind: "Variable",
      name: "afterAccepted",
      variableName: "afterAccepted",
      type: null,
    },
    {
      kind: "Variable",
      name: "afterCancelled",
      variableName: "afterCancelled",
      type: null,
    },
    {
      kind: "Variable",
      name: "afterPending",
      variableName: "afterPending",
      type: null,
    },
    {
      kind: "Variable",
      name: "afterRejected",
      variableName: "afterRejected",
      type: null,
    },
    {
      kind: "Variable",
      name: "countAccepted",
      variableName: "countAccepted",
      type: null,
    },
    {
      kind: "Variable",
      name: "countCancelled",
      variableName: "countCancelled",
      type: null,
    },
    {
      kind: "Variable",
      name: "countPending",
      variableName: "countPending",
      type: null,
    },
    {
      kind: "Variable",
      name: "countRejected",
      variableName: "countRejected",
      type: null,
    },
  ];
  return {
    kind: "Fragment",
    name: "Routes_user",
    type: "UserType",
    metadata: null,
    argumentDefinitions: [
      {
        kind: "LocalArgument",
        name: "countPending",
        type: "Int",
        defaultValue: 6,
      },
      {
        kind: "LocalArgument",
        name: "afterPending",
        type: "String",
        defaultValue: "",
      },
      {
        kind: "LocalArgument",
        name: "countAccepted",
        type: "Int",
        defaultValue: 6,
      },
      {
        kind: "LocalArgument",
        name: "afterAccepted",
        type: "String",
        defaultValue: "",
      },
      {
        kind: "LocalArgument",
        name: "countRejected",
        type: "Int",
        defaultValue: 6,
      },
      {
        kind: "LocalArgument",
        name: "afterRejected",
        type: "String",
        defaultValue: "",
      },
      {
        kind: "LocalArgument",
        name: "countCancelled",
        type: "Int",
        defaultValue: 6,
      },
      {
        kind: "LocalArgument",
        name: "afterCancelled",
        type: "String",
        defaultValue: "",
      },
    ],
    selections: [
      {
        kind: "FragmentSpread",
        name: "BaseHorizontal_user",
        args: null,
      },
      {
        kind: "FragmentSpread",
        name: "Dashboard_user",
        args: v0,
      },
      {
        kind: "FragmentSpread",
        name: "Account_user",
        args: null,
      },
      {
        kind: "FragmentSpread",
        name: "Absences_user",
        args: v0,
      },
      {
        kind: "ScalarField",
        alias: null,
        name: "displayName",
        args: null,
        storageKey: null,
      },
      {
        kind: "ScalarField",
        alias: null,
        name: "isStaff",
        args: null,
        storageKey: null,
      },
    ],
  };
})();
// prettier-ignore
(node/*: any*/).hash = '6038da757f866b6d42d454783b260b94';
module.exports = node;



// WEBPACK FOOTER //
// ./src/__generated__/Routes_user.graphql.js